import {
  SEND_CONTACT_SUCCESS,
  SEND_CONTACT_FAILURE,
} from '../actions/types'

const initialState = {
  responseStatus: '',
}

const contact = (state = initialState, action) => {
  switch (action.type) {
    case SEND_CONTACT_SUCCESS:
      return {
        ...state,
        ...action.payload,
        responseStatus: 200,
      }
    case SEND_CONTACT_FAILURE:
      return {
        ...state,
        ...action.payload,
        responseStatus: 401,
      }
    default:
      return state
  }
}

export default contact



// WEBPACK FOOTER //
// ./src/reducers/contact.js